
export default [
  {
    key: 'office',
    label: '支店',
    style: {
      maxWidth: 100,
      // width: 120,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }
  }, 
  {
    key: 'kenmei1',
    label: '件名',
    style: {
      maxWidth: 200,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      // overflow: 'hidden'
    }
  },
  // {
  //   key: 'kenmei2',
  //   label: '件名名称・顧客',
  //   style: {
  //     width: 130,
  //     overflow: 'hidden'
  //   }
  // },
  {
    key: 'linear',
    label: '請求・受注比率',
    style: {
      // overflow: 'hidden'
    }
  },
  {
    key: 'arari',
    label: '粗利率',
    style: {
      maxWidth: 70,
      // overflow: 'hidden'
    }
  },
  {
    key: 'status',
    label: '状況',
    style: {
        maxWidth: 80,
    }
  },
  {
    key: 'actions',
    label: '',
    style: {
        maxWidth: 60,
    }
  },
];


// WEBPACK FOOTER //
// ./src/containers/yosan/listHeader.js